export enum ThemeEnum {
  Light = 'light',
  Dark = 'dark',
}
export type Theme = ThemeEnum | `${ThemeEnum}`;

export enum MenuTypeEnum {
  Checkbox = 'checkbox',
  Radio = 'radio',
  Item = 'item',
}
export type MenuType = MenuTypeEnum | `${MenuTypeEnum}`;
